import React, { useEffect, useState } from 'react';
import './styles.css';
import HomeLayout from '../../../layout/HomeLayout';
import InformeForm from './InformeForm';


const InformePagamentos: React.FC = () => {
  return (
    <HomeLayout>
      <div className='width-100 login-container-end'>
        <InformeForm />
      </div>
    </HomeLayout>
  );
};

export default InformePagamentos;
